import { render, staticRenderFns } from "./DiscountCreateModal.vue?vue&type=template&id=d0a2a358"
import script from "./DiscountCreateModal.vue?vue&type=script&lang=js"
export * from "./DiscountCreateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports